import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const tableHead = [
  "Sr.",
  "Client Name / Trainee Name",
  "start date",
  "progress",
  "Actions",
];
const getProgress = (tasks = []) => {
  let data = tasks?.filter((el) => el.activityDone) || [];
  return `${data?.length} / ${tasks?.length}`;
};
const LabaourTrainingScheduleTable = ({
  data = [],
  currentPage,
  itemsPerPage,
}) => {
  const navigate = useNavigate();
  const store = useSelector((store) => store.login.user);

  const goToView = (id) => {
    navigate(`/labour-training/view/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>

                <td>
                  <span>
                    {(
                      item?.Client?.clientName ||
                      item?.Client?.businessName ||
                      "N/A"
                    ).toUpperCase()}
                  </span>
                  <br /><hr className="m-0 p-0"></hr>
                  <span>{item?.labourName.toUpperCase() || "N/A"}</span>
                </td>
                <td>{item?.startDate || "N/A"}</td>
                <td>{getProgress(item?.labourSchedule) || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default LabaourTrainingScheduleTable;
